class StringUtil {
    constructor(){}

    // null 값을 ''으로 변환
    nullToEmptyString(string) {
        if (string == null) {
            return '';
        }
        return string;
    }

    // line feed(\n)를 공백(' ')으로 치환
    replaceLineFeed(string) {
        return string.replace(/\n/g, ' ');
    }

    // headers와 items로 구성된 table에서 원하는 header의 index에 해당하는 데이터만 csv 포맷으로 변환
    /*
        header에는 text와 value라는 key가 있어야 함
        item의 key는 header의 value여야 함
    
        headers: [
            { text: '변수명', value: 'variableMeaning' },
            { text: '변수값', value: 'variableExp' },
            { text: '예시', value: 'description' },
        ],

        items: [
            { variableMeaning: '거주지', variableExp: '{{$address}}', description: '서울시 강남구 삼성동 12 삼성아파트 210동 1102호' },
            { variableMeaning: '생년월일', variableExp: '{{$birth_date}}', description: '7월5일' },
        ],

        headerIndexArr: [0, 1, 2],
    */
    tableToCsvDataString(headers, items, headerIndexArr) {
        const BOM = '\uFEFF';
        let dataString = BOM;
  
        // header
        for (var index of headerIndexArr) {
            let temp = this.replaceLineFeed(this.nullToEmptyString(headers[index].text));
            if (temp.includes(',')) {
                dataString += '"' + temp + '",'; // 문자열 안에 csv 기본 구분자인 comma(,)가 포함되어 있을 경우 밀림 방지를 위해 double quotes(")로 감싸줌
            } else {
                dataString += temp + ',';
            }
        }
        dataString = dataString.replace(/,$/, '\n'); // 문자열이 comma(,)로 끝나면 line feed(\n)로 치환
  
        // items      
        for (var item of items) {
          for (var index of headerIndexArr) {
            let temp = this.replaceLineFeed(this.nullToEmptyString(item[headers[index].value]));
            if (temp.includes(',')) {
                dataString += '"' + temp + '",'; // 문자열 안에 csv 기본 구분자인 comma(,)가 포함되어 있을 경우 밀림 방지를 위해 double quotes(")로 감싸줌        
            } else {
                dataString += temp + ',';
            }
          }
          dataString = dataString.replace(/,$/, '\n'); // 문자열이 comma(,)로 끝나면 line feed(\n)로 치환
        }
  
        return dataString;
    }

    // 재시도 콜의 item_index를 캠페인 수신리스트 작성시 최초 채번된 item_index로 보정하고, 정해진 수신ID 포맷으로 변환
    // 최초 item_index : 1 -> C00001, 2 -> C00002
    // 재시도 콜의 item_index : 1000001 -> C00001, 200001 -> C00001
    // (재시도 콜의 item_index = 직전 콜의 item_index + 1000000)
    itemIndexToCalleeId(string) {
        string = '' + string; // String type이 아닌 경우 type 변환
        return 'C' + string.slice(-5).padStart(5, '0');
    }

    // 2차원 배열의 문자열 안에 csv 행 구분자인 line feed(\n) 또는 열 구분자인 comma(,)가 포함되어 있을 경우 밀림 방지를 위해 double quotes(")로 감싸줌
    enclose2DArrayInDoubleQuotes(array) {
        array.forEach(element => {
            element.forEach((subElement, subIndex) => {
                let temp = '' + subElement; // string 타입이 아닌 경우가 있으므로, 타입 변환
                if (temp.includes(',') || temp.includes('\n')) {
                    element[subIndex] = '"' + temp + '"';
                }
            });
        });
        return array;
    }   
}

export default StringUtil;